import {Http} from '@/model/Http.js'

export default class pay extends Http {
  // 退款设置说明获取
  getRefundSetting(data) {
    const url = '/open/open/config/get'
    return this.postAjaxByMini(url, data)
  }
  
  // 设置退款说明
  setRefundRemark(data) {
    const url = '/open/open/config/save-value'
    return this.postAjaxByMini(url,data)
  }
  
  // 团长列表
  getAgentSearch(data) {
    const url = '/open/open/dy-life/agent/search'
    return this.postAjaxByMini(url, data)
  }
  
  // 团长列表导出
  exportAgentSearch(data) {
    const url = '/open/open/dy-life/agent/search-export'
    return this.postAjaxByMini(url, data)
  }
  
  // 关联达人列表
  getDarenList(data) {
    const url = '/open/open/dy-life/daren/my-daren-list'
    return this.postAjaxByMini(url, data)
  }
  
  // 关联达人列表导出
  exportDarenList(data) {
    const url = '/open/open/dy-life/agent/search'
    return this.postAjaxByMini(url, data)
  }
  
  // 推广商品数
  getDistributeGoodsNum(data) {
    const url = '/open/open/dy-life/agent/my-goods-stat'
    return this.postAjaxByMini(url, data)
  }
  
  // 团长服务费
  getSettledCommission(data) {
    const url = '/open/open/dy-life/agent/my-settled-list'
    return this.postAjaxByMini(url, data)
  }

  saveGroupInfo(data) {
    const url = '/open/open/dy-life/agent/save-info'
    return this.postAjaxByMini(url, data)
  }
  
  // 给达人的联系方式
  queryGroupInfo(data) {
    const url = '/open/open/dy-life/agent/get-info'
    return this.postAjaxByDouYin(url, data, true)
  }
  
  // 我的商品列表
  getMyGoodsList(data) {
    const url = '/open/open/dy-life/agent/my-goods-list'
    return this.postAjaxByMini(url, data)
  }
  
  // 商品列表
  getChooseList(data) {
    const url = '/open/open/dy-life/agent/choose-goods-list'
    return this.postAjaxByMini(url, data)
  }
  
  // 保存商品
  saveGoods(data) {
    const url = '/open/open/dy-life/agent/save-goods'
    return this.postAjaxByMiniNew(url, data)
  }
  
  // 删除商品
  deleteGoods(data) {
    const url = '/open/open/dy-life/agent/del-goods'
    return this.postAjaxByMiniNew(url, data)
  }
  
  // 分销推广二维码
  getDistributeQrCode(data) {
    const url = '/open/open/dy-life/daren/distribute-qr-code'
    return this.postAjaxByMini(url, data)
  }
  
  // 团长下级达人列表
  getMyDarenList(data) {
    const url = '/open/open/dy-life/daren/my-daren-goods-list'
    return this.postAjaxByMini(url, data)
  }

  // 解绑达人
  unbindDaren(data) {
    const url = '/open/open/dy-life/daren/unbind'
    return this.postAjaxByMini(url, data)
  }
  
  // 券佣金结算列表导出
  exportMySettledListExport (data) {
    const url = '/open/open/dy-life/agent/my-settled-list-export'
    return this.postAjaxByMini(url, data)
  }
  
  // 资金流水导出
  exportUserBalanceLogExport (data) {
    const url = '/open/open/dy-life/agent/user-balance-log-export'
    return this.postAjaxByMini(url, data)
  }

  // 团长下级达人列表导出
  exportMyDarenListExport (data) {
    const url = '/open/open/dy-life/daren/my-daren-list-export'
    return this.postAjaxByMini(url, data)
  }
}



// WEBPACK FOOTER //
// ./src/api/poi.js